import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

export default ({
    action,
    fetchedData,
    onClickTestGet,
    onClickTestEntity,
    onClickReset,
}) => <React.Fragment>
        <Grid item container direction="row" spacing={2}>
            <Grid item>
                <Button variant="contained" color="primary" onClick={onClickTestGet}>{'test-get'}</Button>
            </Grid>
            <Grid item>
                <Button variant="contained" color="primary" onClick={onClickTestEntity}>{'test-db'}</Button>
            </Grid>
            <Grid item>
                <Button variant="contained" color="secondary" onClick={onClickReset}>{'RESET'}</Button>
            </Grid>
        </Grid>
        <Typography variant="h5">{'You clicked:'}</Typography>
        <Typography>{action}</Typography>
        <Typography variant="h5">{'Result:'}</Typography>
        {
            fetchedData && Object.keys(fetchedData).map(k =>
                <Typography key = {k}><strong>{k}: </strong>{fetchedData[k]}</Typography>)
        }
    </React.Fragment>